// extracted by mini-css-extract-plugin
export var accordionHeaderRootCustom = "Footer-mps-module--accordionHeaderRootCustom--2691c";
export var accordionTitleCustom = "Footer-mps-module--accordionTitleCustom--b739c";
export var link = "Footer-mps-module--link--80265";
export var root = "Footer-mps-module--root--7a2e4";
export var show = "Footer-mps-module--show--3ab26";